import login from './login';

export default {
  language: 'fr',
  country: 'fr',
  name: 'Français',
  embeddedLocale: login,
};
